import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Crop } from '../classes/cropModel';
import { CropVariety } from '../classes/cropVarietyModel';
import { TokenStorageService } from './token.service';
@Injectable({
  providedIn: 'root'
})
export class CropsService {
  constructor(public http: HttpClient, private tokenStorageService: TokenStorageService) {}
  async getCategoriesCount(obj) {
    let body = {
      target: "getCropCategoriesCount",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        console.log("result", result);
        resolve(result)
      }, reject);
    })
  }
  async getCategories(obj) {
    let body = {
      target: "getCropCategories",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropscount(obj) {
    let body = {
      target: "getCropDataCount",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropData(obj) {
    let body = {
      target: "getCropData",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async createCrop(crop: Crop) {
    let body = {
      target: "saveCropData",
      source: crop,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async createCropCategory(crop: Crop) {
    let body = {
      target: "saveCropCategories",
      source: crop,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateCrop(crop: Crop) {
    let obj = {
      maincropId: crop.maincropId,
      group: crop.group
    }
    let body = {
      target: "updateCropData",
      source: crop,
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateCropCategory(categoryObj) {
    let obj = {
      categoryId: categoryObj.categoryId,
      group: categoryObj.group
    }
    let body = {
      target: "updateCropCategories",
      source: categoryObj,
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropRegex(obj) {

    let body = {
      target: "getCropRegex",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropCategoryRegex(obj) {
    let body = {
      target: "getcropCategoryRegex",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropById(obj) {
    let body = {
      target: "getCropData",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getVarietyCount(obj) {
    let body = {
      target: "getCropVarietiesCount",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getAllCropsVariety(obj) {
    let body = {
      target: "getCropVarieties",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropByCategory(obj) {
    let body = {
      target: "getCropData",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropVarietiesCount(obj) {
    let body = {
      target: "getCropVarietiesCount",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getCropVarieties(obj) {
    let body = {
      target: "getCropVarieties",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async pushCropVariety(cropvariety: CropVariety) {
    let body = {
      target: "saveCropVarieties",
      source: cropvariety,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateCropVariety(crop) {
    let obj = {
      maincropId: crop.maincropId,
      group: crop.group
    }
    let body = {
      target: "updateCropVarieties",
      source: crop,
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        console.log("result", result);
        resolve(result)
      }, reject);
    })
  }
  async getcropvarietiesRegex(obj) {
    let body = {
      target: "getcropvarietiesRegex",
      query: obj,
      lKey: "Crop"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.healthReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
}